class CodectibleFeaturedMedia extends HTMLElement {
    constructor() {
        super();
        this.mediaControl = this.querySelector('.js-video-control')
        this.container = this.querySelector('.featured-codectible-media-container')
        this.videos = this.querySelectorAll('.codectible-featured-video');
        this.lastWindowWidth = window.innerWidth;

        this.setupEventListeners();
    }

    setupEventListeners(){
        this.mediaControl.addEventListener('click', this.handleMediaControlClick.bind(this));
        this.videos.forEach((video) => {
            video.addEventListener('play', this.handleVideoPlay.bind(this));
            video.addEventListener('pause', this.handleVideoPause.bind(this));
            
        })

        window.addEventListener('resize', throttle(this.handleResize.bind(this), 500));
    }

    /*

    we need to pause video for each breakpoint because the video elements are different
    for desktop and mobile
    
    */
    handleResize(){
        
        const currentWindowWidth = window.innerWidth;
        const mobileBreakpoint = 768

        //pause all video when it hits breakpoint
        if( (this.lastWindowWidth > mobileBreakpoint && currentWindowWidth <= mobileBreakpoint)
        || (this.lastWindowWidth <= mobileBreakpoint && currentWindowWidth > mobileBreakpoint )
        ){
            this.pauseAllVideos()
        }

        this.lastWindowWidth = currentWindowWidth;

    }

    pauseAllVideos(){
        this.videos.forEach((video) => {
            video.pause();
        })
    }

    handleVideoPlay(event){
        let video = event.target;

        this.container.classList.add('is-playing');

    }

    handleVideoPause(event){
        let video = event.target;

        this.container.classList.remove('is-playing');
    }

    handleMediaControlClick(event){
        let element = event.target;
        let control = element.dataset.control;

        if(control == "play"){
            this.videos.forEach((video) => {
                //check if video is hidden or visible

                //automatically pause if video is hidden
                if(video.offsetParent === null){
                    video.pause();
                }else{

                    if(video.paused){
                        video.play();
                    }else{
                        video.pause();
                    }
                }
            })
        }
    }

}

customElements.define('codectible-featured-media', CodectibleFeaturedMedia);